<template>
  <!-- data-testid: pruebas automáticas (e2e/) -->
  <div class="zapi-back-btn" data-testid="pos-salir" @click="volver">
    <i class="pi pi-arrow-left"></i>
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'ZapiBackButton',
  props: {
    label: {
      type: String,
      default: 'Salir'
    },
    ruta: {
      type: [String, Object],
      default: null
    }
  },
  methods: {
    volver() {
      if (this.ruta) {
        this.$router.push(this.ruta);
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>

<style scoped>
.zapi-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 2px solid #f0ebe2;
  border-radius: 1rem;
  padding: 1rem 1rem;
  background-color: white;
  color: #4b5563;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  height: 100%;
}
.zapi-back-btn:hover {
  background-color: #f9fafb;
  border-color: #e32f3a;
  color: #e32f3a;
}
</style>
